import React from 'react';
import { Box, FormControl, FormHelperText, InputLabel, MenuItem, Select, SelectProps, Typography } from '@mui/material';

import { LocalizationContext } from '@cvt/contexts';
import { getMeetingStatusLabel } from '../helpers/meeting';
import { MEETING_STATUS_LIST } from '../enums';


export type MeetingStatusSelectProps = Omit<SelectProps<string | null>, 'renderValue'> & {
  error?: boolean;
  helperText?: React.ReactNode;
  placeholder?: string;
  fullWidth?: boolean;
};

export const MeetingStatusSelect = React.forwardRef<HTMLDivElement, MeetingStatusSelectProps>((props, ref) => {
  const { error, helperText, placeholder, label, fullWidth = true, ...selectProps } = props;
  const { dictionary } = React.useContext(LocalizationContext);

  return (
    <Box width={fullWidth ? '100%' : undefined}>
      <FormControl fullWidth={fullWidth}>
        <InputLabel>{label}</InputLabel>
        <Select
          displayEmpty
          label={label}
          {...selectProps}
          ref={ref}
          color="primary"
          renderValue={(selected) => {
            const meetingStatus = MEETING_STATUS_LIST.find((meetingStatus) => meetingStatus === selected);
            if (!meetingStatus) {
              return (
                <span style={{ color: '#a2a2a2' }}>
                  {placeholder || dictionary.forms.meeting.meetingStatusPlaceholder}
                </span>
              );
            }
            return (
              <Typography>
                {getMeetingStatusLabel(dictionary, meetingStatus as Meetings.MeetingStatus)}
              </Typography>
            );
          }}
          MenuProps={{
            ...selectProps.MenuProps,
            PaperProps: {
              ...selectProps.MenuProps?.PaperProps,
              sx: {
                maxHeight: (36 * 8.5) + 8,
              },
            },
          }}
          error={error}
        >
          <MenuItem value="">
            <span style={{ color: '#a2a2a2' }}>
              {placeholder || dictionary.forms.meeting.meetingStatusPlaceholder}
            </span>
          </MenuItem>
          {MEETING_STATUS_LIST.map((meetingStatus) => (
            <MenuItem key={meetingStatus} value={meetingStatus}  sx={{ textTransform: 'capitalize' }}>
              {getMeetingStatusLabel(dictionary, meetingStatus as Meetings.MeetingStatus)}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      {!!helperText && (
        <FormHelperText error={error}>{helperText}</FormHelperText>
      )}
    </Box>
  );
});
